<app-navbar-style-one></app-navbar-style-one>

<div class="inner-banner">
    <div class="container">
        <div class="goBackBtn text-end px-5">
           
        </div>
        <div class="inner-title text-center">
            <h3>عربة التسوق</h3>
        </div>
    </div>
</div>

<div class="alert alert-success text-center" *ngIf="showSuccess" style="position: fixed;top: 20%;direction: ltr;left: 50%;transform: translate(-50%, -50%);z-index: 99999999999999;">
    {{successMsg}}
</div>

<div class="alert alert-danger text-center" *ngIf="showError" style="position: fixed;top: 20%;direction: ltr;left: 50%;transform: translate(-50%, -50%);z-index: 99999999999999;">
    {{errorMsg}}
</div>


<section class="cart-wraps-area ptb-100">
    <div class="container-fluid px-4">
        <form>
            <div class="cart-wraps">
                <div class="cart-table table-responsive">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">صورة المنتج</th>
                                <!-- <th scope="col">اسم المنتج</th> -->
                                <th scope="col">الحجم و السعر</th>
                                <!-- <th scope="col">السعر</th> -->
                                <th scope="col">الكمية</th>
                                <th scope="col">المجموع</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of cart">
                                <td class="product-thumbnail">
                                    <a routerLink="/products-details/{{item.name}}/{{item.id}}">
                                        <img src="{{item.avatar}}" alt="{{item.name}}">
                                    </a>
                                    <br>
                                    <p class="unit-amount">{{item.name}}</p>
                                </td>
                                <!-- <td class="product-name">
                                    <a routerLink="/products-details/{{item.name}}/{{item.id}}">{{item.name}}</a>
                                </td> -->
                                <td class="product-type">
                                    <span *ngIf="item.selectedTypeId" class="unit-amount">
                                        {{ getTypeName(item.types, item.selectedTypeId) }}
                                    </span>
                                    <p></p>
                                    <span *ngIf="item.selectedTypeId" class="unit-amount">
                                        {{ getTypePrice(item.types, item.selectedTypeId) }} EGP
                                    </span>
                                    <span *ngIf="item.offer" class="text-danger small d-block">
                                        خصم {{item.offer.value}}%
                                    </span>
                                </td>
                                <!-- <td class="product-price">
                                    <span *ngIf="item.selectedTypeId" class="unit-amount">
                                        {{ getTypePrice(item.types, item.selectedTypeId) }} EGP
                                    </span>
                                    <span *ngIf="item.offer" class="text-danger small d-block">
                                        خصم {{item.offer.value}}%
                                    </span>
                                </td> -->
                                <td class="product-quantity">
                                    <div class="input-counter">
                                        <span class="minus-btn" (click)="decreaseQuantity(item)"><i class='bx bx-minus'></i></span>
                                        <input type="text" [value]="item.quantity" readonly>
                                        <span class="plus-btn" (click)="increaseQuantity(item)"><i class='bx bx-plus'></i></span>
                                    </div>
                                </td>
                                <td class="product-subtotal">
                                    <span class="subtotal-amount">
                                        {{ calculateSubtotal(item) }} EGP
                                    </span>
                                    <a (click)="removeItem(item,item.id)" class="remove"><i class='bx bx-trash'></i></a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- <div class="cart-buttons">
                    <div class="row align-items-center">
                        <div class="col-lg-7 col-sm-7 col-md-7">
                            <div class="continue-shopping-box">
                                <a routerLink="/category" class="default-btn">متابعة التسوق</a>
                            </div>
                        </div>

                        <div class="col-lg-5 col-sm-5 col-md-5 text-end">
                            <a routerLink="/cart" class=" default-btn" (click)="updateCartOnServer()">تحديث عربة التسوق</a>
                        </div>
                    </div>
                </div> -->
            </div>
            
            <div class="row">
                <div class="col-lg-6">
                    <div class="cart-calc">
                        <div class="cart-wraps-form"> 
                            <h3>طريقة الدفع</h3>

                            <div class="row text-start px-4">
                                <div class="form-group col-12" dir="ltr">
                                    <label class="form-check-label ms-2" for="flexRadioDefault1">نقدي</label>
                                    <span class="cash-card">
                                        <img src="../../../../assets/img/cash.png" width="25">
                                    </span>
                                    <input type="radio" name="paymentMethod" checked id="flexRadioDefault1" value="Cash" class="form-check-input" placeholder="Card Verification Number">
                                </div>
                                <div class="form-group col-12" dir="ltr">
                                    <label class="form-check-label ms-2" for="flexRadioDefault2">بطاقة (قريبا)</label>
                                    <span class="cash-card">
                                        <img src="../../../../assets/img/card.png" width="25">
                                    </span>
                                    <input type="radio" name="paymentMethod" disabled id="flexRadioDefault2" value="Card ( SOON )" class="form-check-input" placeholder="Card Verification Number">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="cart-calc">
                        <div class="cart-wraps-form"> 
                            <h3>طريقة التسليم</h3>

                            <div class="row text-start px-4">
                                <div class="form-group col-12" dir="ltr">
                                    <label class="form-check-label ms-2" for="delivery">توصيل</label>
                                    <input type="radio" name="deliveryMethod" checked id="delivery" (click)="setDeliveryMethod('delivery')" value="delivery" class="form-check-input">
                                </div>
                                <div class="form-group col-12" dir="ltr">
                                    <label class="form-check-label ms-2" for="pickUp">استلم</label>
                                    <input type="radio" name="deliveryMethod" id="pickUp" (click)="setDeliveryMethod('pickUp')" value="pickUp" class="form-check-input">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="col-lg-12">
                    <div class="cart-totals text-center">
                        <!-- <h3>Cart Totals</h3>
                        <ul>
                            <li>Subtotal <span>$150.00</span></li>
                            <li>Shipping <span>$30.00</span></li>
                            <li>Coupon <span>$20.00</span></li>
                            <li>Total <span><b>$160.00</b></span></li>
                        </ul> -->
                        <a routerLink="/checkout" class="default-btn default-hot-toddy">انتقل إلى الدفع</a>
                    </div>
                </div>
            </div>
        </form>
    </div>
</section>

<!-- <app-footer-style-two></app-footer-style-two> -->